import React, { useState, useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const CATEGORIES = [
    { value: 'common', label: 'Common' },
    { value: 'salaried', label: 'Salaried' },
    { value: 'selfEmployed', label: 'Self-Employed' },
    { value: 'nri', label: 'NRI' },
    { value: 'property', label: 'Property' }
];

const DocumentModal = ({ isOpen, onClose, onSubmit, document, loading, loanType }) => {
    const [formData, setFormData] = useState({
        document_name: '',
        category: 'common',
        display_order: 0,
        is_active: true,
        loan_type: loanType
    });

    useEffect(() => {
        if (document) {
            setFormData({
                ...document,
                is_active: document.is_active === 1 || document.is_active === true
            });
        } else {
            setFormData({
                document_name: '',
                category: 'common',
                display_order: 0,
                is_active: true,
                loan_type: loanType
            });
        }
    }, [document, loanType]);

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
                <div className="flex items-center justify-between px-8 py-6 border-b border-slate-100">
                    <h2 className="text-2xl font-bold text-slate-800">
                        {document ? 'Edit Document' : 'Add New Document'}
                    </h2>
                    <button onClick={onClose} className="p-2 hover:bg-slate-100 rounded-full transition-colors">
                        <XMarkIcon className="h-6 w-6 text-slate-500" />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="p-8 space-y-6">
                    {/* Document Name */}
                    <div>
                        <label className="block text-sm font-semibold text-slate-700 mb-2">
                            Document Name
                        </label>
                        <textarea
                            required
                            rows="2"
                            value={formData.document_name}
                            onChange={(e) => setFormData({ ...formData, document_name: e.target.value })}
                            className="w-full px-4 py-3 border border-slate-200 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all outline-none"
                            placeholder="Enter document name..."
                        />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {/* Category */}
                        <div>
                            <label className="block text-sm font-semibold text-slate-700 mb-2">
                                Category
                            </label>
                            <select
                                value={formData.category}
                                onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                                className="w-full px-4 py-3 border border-slate-200 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
                            >
                                {CATEGORIES.map((cat) => (
                                    <option key={cat.value} value={cat.value}>
                                        {cat.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Display Order */}
                        <div>
                            <label className="block text-sm font-semibold text-slate-700 mb-2">
                                Display Order
                            </label>
                            <input
                                type="number"
                                value={formData.display_order}
                                onChange={(e) => setFormData({ ...formData, display_order: parseInt(e.target.value) })}
                                className="w-full px-4 py-3 border border-slate-200 rounded-2xl focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none"
                            />
                        </div>

                        {/* Active Status */}
                        <div>
                            <label className="block text-sm font-semibold text-slate-700 mb-2">
                                Status
                            </label>
                            <button
                                type="button"
                                onClick={() => setFormData({ ...formData, is_active: !formData.is_active })}
                                className={`w-full flex items-center justify-between px-6 py-3 rounded-2xl border transition-all ${formData.is_active
                                        ? 'bg-green-50 border-green-200 text-green-700'
                                        : 'bg-slate-50 border-slate-200 text-slate-500'
                                    }`}
                            >
                                <span className="font-semibold">{formData.is_active ? 'Active' : 'Inactive'}</span>
                                <div className={`w-10 h-6 rounded-full relative transition-all ${formData.is_active ? 'bg-green-500' : 'bg-slate-300'}`}>
                                    <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${formData.is_active ? 'left-5' : 'left-1'}`}></div>
                                </div>
                            </button>
                        </div>
                    </div>
                </form>

                <div className="px-8 py-6 bg-slate-50 border-t border-slate-100 flex justify-end gap-3">
                    <button
                        type="button"
                        onClick={onClose}
                        className="px-6 py-3 rounded-xl font-semibold text-slate-600 hover:bg-slate-200 transition-all"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        disabled={loading}
                        className="bg-primary-600 hover:bg-primary-700 text-white px-8 py-3 rounded-xl font-semibold transition-all disabled:opacity-50 shadow-lg"
                    >
                        {loading ? 'Saving...' : document ? 'Update Document' : 'Create Document'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DocumentModal;
